import {
  FormFieldWidget,
  http,
  ILevel,
  ModelFieldType,
  SPI,
  useMessageHub,
  ViewType,
  Widget
} from '@kunlun/dependencies';
import SendVerifyCode from './SendVerifyCode.vue';

@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: ViewType.Form,
    ttype: ModelFieldType.String,
    widget: 'SendVerifyCode',
    multi: false
  })
)
export class FormStringSendVerifyCodeFieldWidget extends FormFieldWidget {
  public initialize(props) {
    super.initialize(props);
    this.setComponent(SendVerifyCode);
    this.submitErrorHandler();

    return this;
  }

  @Widget.Method()
  private async sendCode() {
    const gql = `
      mutation {
        pamirsUserTransientMutation {
          sendSmsVerificationCode(user: { 
            phone: "${this.formData.phone}"
            userBehaviorEvent: MODIFY_PHONE_NEW_PHONE_CODE
          }) {
            broken
            errorMsg
            errorCode
            errorField
          }
        }
      }
    `;

    const res = await http.mutate('user', gql);
    return res.data.pamirsUserTransientMutation.sendSmsVerificationCode;
  }

  @Widget.Method()
  private onInput(e: InputEvent) {
    // @ts-ignore
    this.formData.code = e.target!.value;
  }

  private submitErrorHandler() {
    const hub = useMessageHub(Date.now() + '');
    hub.subscribe((error) => {
      console.log(error);

      hub.unsubscribe();
    }, ILevel.ERROR);
  }
}
